import { AntennesUtilisateurApiObject } from '@europrocurement/l2d-domain';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faMapLocation } from '@fortawesome/pro-solid-svg-icons';
import { Avatar, Chip, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

type AntennaHeaderProps = {
    antenne: AntennesUtilisateurApiObject;
};

export const AntennaHeader: React.FunctionComponent<AntennaHeaderProps> = function ({ antenne }) {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            sx={{ margin: '0px 0px 18px 0px' }}
        >
            <Avatar
                sx={{
                    width: 64,
                    height: 64,
                    marginRight: '15px',
                    borderRadius: '8px',
                    backgroundColor: theme.palette.primary.dark,
                }}
            >
                <FaOptionIcon icon={faMapLocation} />
            </Avatar>

            <Box
                display="flex"
                flexDirection="column"
            >
                <Typography
                    variant="l2dh5"
                    sx={{ lineHeight: '1.4' }}
                >
                    {`${antenne.libelle}`}

                    {antenne.isDeleted ? (
                        <Chip
                            sx={{ marginLeft: '8px' }}
                            color="default"
                            label="Antenne désactivée"
                        />
                    ) : (
                        <Chip
                            sx={{ marginLeft: '8px' }}
                            color="primary"
                            label="Antenne active"
                        />
                    )}
                </Typography>
                <Typography
                    data-testid="idUser"
                    sx={{ lineHeight: '2' }}
                    variant="l2dbodys"
                    color="text.gris70"
                >
                    <b>Identifiant : </b>
                    {antenne.idAntenne}
                </Typography>
            </Box>
        </Box>
    );
};
